export default {
  login: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    passwordRequired: "passwordRequired"
  },
  logout: {
    succeed: "logoutSucceed",
    failed: "logoutFailed"
  },
  request: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    processing: "requestProcessing",
    delayed: "requestDelayed"
  },
  session: {
    invalidToken: "session_not_exists",
    invalidSession: "session_expired",
    inactiveAccount: "account_inactive",
  },
  forgotPassword: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    phoneRequired: "phoneRequired"
  },
  memberSignUp: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    passwordRequired: "passwordRequired",
    emailRequired: "emailRequired",
  },
  memberTacValidate: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    tacCodeRequired: "tacCodeRequired"
  },
  memberRenewTac: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  mbTacLogin: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  mbNewLogin: {
    succeed: "loginSucceed",
    failed: "loginFailed",
    usernameRequired: "usernameRequired",
    otpRequired: "otpRequired"
  },
  getBalance: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  bankLookUp: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberBankList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberEwallet: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  activeList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getBankingMode: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRebate: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRebateDownline:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRefereeList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  claimRebate:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  claimRebateDownline:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getTurnoverProvider: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getSocialList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getRtplist:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  updatePassword: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    passwordRequired: "passwordRequired",
    newPasswordRequired: "newPasswordRequired"
  },
  profileUpdate:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  memberAddBank: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    bankIdRequired: "bankIdRequired",
    bankNameRequired: "bankNameRequired",
    bankAccHolderRequired: "bankAccHolderRequired",
    bankAccNoRequired: "bankAccNoRequired",
    // tacCodeRequired: "tacCodeRequired"
  },
  memberAddEwallet: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    bankIdRequired: "walletIdRequired",
    bankAccHolderRequired: "walletHolderRequired",
    bankAccNoRequired: "walletNoRequired",
    // tacCodeRequired: "tacCodeRequired"
  },
  setDefaultBank: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    bankIdRequired: "bankIdRequired",
    bankAccNoRequired: "bankAccNoRequired",
  },
  memberBankTac: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  depositOfaPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired"
  },
  manualDeposit: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
    bankIdRequired: "bankIdRequired"
  },
  getMemberTicketList: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getTurnoverDownline: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getPromotionStatus: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberVip: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  addWithdrawTicket: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    withdrawal_amount_required: "withdrawal_amount_required",
    bankIdRequired: "bankIdRequired",
    bankAccNoRequired: "bankAccNoRequired",
  },
  getStatement: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getMemberGameResult: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getPromo:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    dateRequired:"dateRequired"
  },
  getBet:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    dateRequired:"dateRequired"
  },
  getInbox:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  claimInbox:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    bonusIdRequired: "bonusIdRequired"
  },
  launchGame:{
    success: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getQuestion:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  submitReview:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    commentRequired: "commentRequired",
    ratingRequired: "ratingRequired"
  },
  getSurveyList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  mayaPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  htPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  aiPay:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  rmPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  gopayGcash: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  gopayMaya: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  dgpayGcash: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  dgpayGcashqr: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  dgpayMaya: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  cloudPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  topPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  anfuPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  shunfapayGcash: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  shunfapayMaya: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  worldPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  rgPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  wcPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  goldPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  xftgCash: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  xftUsdt: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  masayaPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  xyPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  tygPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  ctPay: {
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    depositAmountRequired: "depositAmountRequired",
  },
  getCouponDetails:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
  },
  updateEmail:{
    accountIdRequired: "accountIdRequired",
    emailRequired: "emailRequired",
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  launchEpic:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchEpic2:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchWbet:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchHabaneroDemo:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchLive22:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchAwc:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchJili:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchFc:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchSabong:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchIronclaw:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchEvo:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchCq9:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchHabanero:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchPps:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchPpc:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchLaunchOne:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchYgr:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchWow:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchTbl:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  launchOpenapi:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getBetList:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getClaimedTickets:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getRealTimeTrans:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getRebateChart:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getXchangeRate:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getStreamLink:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getTopgame:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getPromoDepositCount:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getSpadeResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getHbResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getLive22Result:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getEpic2Result:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getCq9Result:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getHabaneroResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getPpsResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getAwcResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getJiliResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getFcResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getEvoResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getPgsResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getJokerResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getProviderGameOfflist:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    providerRequired: ""
  },
  // getEpicResult:{
  //   succeed: "requestSucceed",
  //   failed: "requestFailed",
  //   accountIdRequired: "accountIdRequired",
  //   resultIdRequired: "resultIdRequired"
  // },
  getPpcResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getLaunchoneResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getYgrResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getWowResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getOpenapiResult:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired",
    resultIdRequired: "resultIdRequired"
  },
  getTokenBalance:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  getSlideBanner:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getAnnBanner:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getPromoBanner:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getSeo:{
    succeed: "requestSucceed",
    failed: "requestFailed",
  },
  getFavlist:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  addFav:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
  removeFav:{
    succeed: "requestSucceed",
    failed: "requestFailed",
    accountIdRequired: "accountIdRequired"
  },
};
